import type {TFunction} from "i18next";

import {ShiftType} from "../types";

const SHIFT_TYPE_KEYS: Record<ShiftType, string> = {
  [ShiftType.NORMAL]: "type.normal",
  [ShiftType.PATROL]: "type.patrol",
  [ShiftType.DISPATCH]: "type.dispatch",
};

export function tShiftTypeName(type: ShiftType | string | undefined, t: TFunction<"shifts">): string {
  if (!type) return "";
  const key = SHIFT_TYPE_KEYS[type as ShiftType];
  return key ? t(key, {defaultValue: String(type)}) : String(type);
}
